<template>
  <div
    class="w-full px-20 sm:px-10 md:px-32 py-10 bg-gray-800 text-gray-300 text-xs sm:text-sm"
  >
    <div class="max-w-[1000px] mx-auto">
      <div class="flex flex-col sm:flex-row justify-between gap-10">
        <div class="flex sm:justify-center">
          <div class="sm:w-auto">
            <h1 class="font-bold py-4">
              <button @click="toHome()">HeroGrow</button>
            </h1>
            <p class="text-gray-400">
              Business growth and web development <br />
              by professionals, for professionals.
            </p>
          </div>
        </div>

        <!-- <div class="flex sm:justify-center sm:w-44">
          <div class="sm:w-full">
            <h1 class="font-bold py-4">
              LOCATION
            </h1>
            <p class="text-gray-400 whitespace-pre">
              {{ address }}
            </p>
          </div>
        </div> -->

        <div class="flex sm:justify-center sm:w-44">
          <div class="sm:w-full">
            <h1 class="font-bold py-4">Contact</h1>
            <div class="text-gray-400 flex flex-col gap-2">
              <a href="mailto:info@herogrow.net" class="flex gap-2">
                <div class="flex gap-2">
                  <Icon icon="material-symbols:mail-outline" height="1.5em" />
                  <h1>info@herogrow.net</h1>
                </div>
              </a>
              <div class="hidden flex gap-2">
                <Icon icon="material-symbols:call-sharp" height="1.5em" />
                <h1></h1>
              </div>
              <div class="hidden flex gap-2">
                <Icon icon="entypo-social:instagram" height="1.5em" />
                <Icon icon="entypo-social:twitter" height="1.5em" />
                <Icon icon="entypo-social:facebook" height="1.5em" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="py-8">
        <hr class="border-0 h-[1px] w-3/4 bg-gray-400" />
      </div>
      <div class="text-gray-400">
        © Herogrow LLC 2026 All rights reserved |
        <a href="/terms">Terms of Service</a>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from "@iconify/vue";

const address = `651 N Broad St
Suite 206
Middletown, DE 19709`;

const toHome = () => (window.location.href = "/");
</script>
